import CloseIcon from '@mui/icons-material/Close';
import { Dialog,DialogContent,DialogTitle } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { trackEventMatomo } from '../../helpers/matomo';

function ModalImageOnTicket({
  image,
  open,
  setOpen,
}: {
  image: string,
  open: boolean,
  setOpen: Function,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={() => {
        trackEventMatomo('chamado', 'click', 'modal', 'fecha visualização de imagem');
        setOpen(false);
      }}
      scroll={'paper'}
    >
      <DialogTitle />
      <DialogTitle />
      <IconButton
        aria-label="close"
        onClick={() => {
          trackEventMatomo('chamado', 'click', 'botão', 'fecha visualização de imagem');
          setOpen(false);
        }}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <img style={{ maxHeight: '75svh' }} src={image} alt={image} />
      </DialogContent>
    </Dialog>
  );
}

export default ModalImageOnTicket;
